export enum Modes {
  vehicle,
  route,
  branch,
}

export type Props = {
  changeTitle: (title: string) => void;
};